import axios from 'axios'

const axiosConfig = {
  baseURL: process.env.VUE_APP_REST_API_FEATUREHUB,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
}
const apiClient = axios.create(axiosConfig)

apiClient.interceptors.response.use(
  function (response) {
    return response
  }
)

export default apiClient
